/**
 * @author  teel
 *
 * contrast shader
 */
import * as THREE from "three";

const ContrastShader = {
  uniforms: {
    tDiffuse: {value: null},
    brightness: {value: -0.04},
    contrast: {value: 0.8},
  },
  vertexShader: require('./Contrast.vert'),
  fragmentShader: require('./Contrast.frag'),

};

export default ContrastShader;
